import { forwardRef } from '@chakra-ui/react-v2';

import { Heading } from '@frontend/legacy-components';

import { useTitleBlockContext } from './utils/TitleBlockContext';

const TitleBlockTitle = forwardRef(({ title, ...props }, ref) => {
  const { size, sizes } = useTitleBlockContext();
  const defaultSize = 'lg';
  const realSize = size || defaultSize;

  return (
    <Heading ref={ref} size={sizes[realSize].titleFontSize} {...props}>
      {title}
    </Heading>
  );
});

export default TitleBlockTitle;
